import { isDate, isValid } from 'date-fns';

export const isValidDate = (date: unknown): date is Date => isValid(date) && isDate(date);
